import { KeyValue, CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, OnInit, inject, signal } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Backend } from 'src/app/backend-interface/backend';
import { Client, Policy } from 'src/app/service/global.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from 'src/app/service/translation.service';
import { HasRolesDirective } from 'keycloak-angular';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-filters-sp',
  templateUrl: './filters-sp.component.html',
  styleUrls: ['./filters-sp.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, NgbDropdownModule, HasRolesDirective, NgbTooltipModule, MatIconModule, MatCheckboxModule, CommonModule, FormsModule],
  providers: [UntypedFormBuilder, TranslationService]

})
export class FiltersSpComponent implements OnInit {

  @Output() applyFilter = new EventEmitter<{ bwvs: number[], clients: number[] }>();

  readonly lPoliciesUser = signal<Policy[]>([]);
  readonly mapBWV = signal<Map<string, number[]>>(new Map());
  readonly clientsList = signal<Client[]>([]);
  readonly chunkArr = signal<string[]>([]);
  readonly selectedBWV = signal<string>("");


  readonly formBuilder = inject(UntypedFormBuilder);
  readonly translationService = inject(TranslationService);
  readonly keycloak = inject(Keycloak);
  readonly formBW = this.formBuilder.group({});
  readonly formClient = this.formBuilder.group({});

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => 0;

  ngOnInit() {
    this.initAsync();
  }

  private async initAsync() {
   
    this.translationService.get('filtre-bw').subscribe((bw: string) => {
      this.selectedBWV.set(bw);
    });
    const policies = await Backend.POLICIES.getPoliciesByFilters(["CREATED", "DESACTIVATED"], [], []);
    this.lPoliciesUser.set(policies);

    const bwvMap = this.getVBW();
    this.mapBWV.set(bwvMap);

    this.chunkArr.set(this.chunkArray(bwvMap));
    this.initFiltreBWV();

    if (this.keycloak.hasRealmRole('bo-dip-wl-admin')) {
      const clients = await Backend.POLICIES.getClients();
      this.clientsList.set(clients);
      this.initFiltreClient();
    }
  }


  initFiltreBWV() {
    const keys = Array.from(this.mapBWV().keys()).map(String);
    Backend.FILTRES.initSimpleForm(keys, this.formBW);
  }

  initFiltreClient() {
    const keys = this.clientsList().map(c => c.name);
    Backend.FILTRES.initSimpleForm(keys, this.formClient);
  }

  getVBW() {
    return Backend.FILTRES.getPoliciesBWVersions(this.lPoliciesUser());
  }

  resetFormBWV() {
    Backend.FILTRES.resetSimpleForm(this.formBW);
  }

  resetFormClient() {
    Backend.FILTRES.resetSimpleForm(this.formClient);
  }

  formatLongString(chaine: string | undefined, n: number) {
    return Backend.FORMAT.formatN(chaine, n);
  }

  getBWVTrue() {
    return Backend.FILTRES.getAllFieldTrue(this.formBW);
  }

  getClientsTrue() {
    return Backend.FILTRES.getAllFieldTrue(this.formClient);
  }

  searchBWVIdsTrue() {
    const formTrue = this.getBWVTrue();
    let listBwIds: number[] = [];
    formTrue.forEach(bwv => {
      if (this.mapBWV().get(bwv)) {
        listBwIds = listBwIds.concat(this.mapBWV().get(bwv) ?? []);
      }
    });
    return listBwIds;
  }

  searchClientsIdsTrue() {
    const formTrue = this.getClientsTrue();
    let listClientsIds: number[] = [];
    formTrue.forEach(client => {
      const clientObj = this.clientsList().find(c => c.name === client);
      if (clientObj) {
        listClientsIds.push(clientObj.id!);
      }
    });
    return listClientsIds;
  }

  applyFilters() {
    this.applyFilter.emit({ bwvs: this.searchBWVIdsTrue(), clients: this.searchClientsIdsTrue() });
  }

  chunkArray(map: Map<string, number[]> | undefined): string[] {
    return map ? Array.from(map.keys()) : [];
  }
}
